import { useEffect, useRef } from 'react';

const useGrid = ({
  showRawHtml,
  htmlEditorInstance,
  textAreaInstance,
  getTextVal
}) => {
  const caretIndex = useRef(null);

  const setCaretIndex = (newCaretIndex) => {
    caretIndex.current = newCaretIndex;
  };

  useEffect(() => {
    if (caretIndex.current !== null) {
      setCaretIndex(null);
    }
  }, [showRawHtml]);

  const setTextVal = (val) => textAreaInstance.current.option('value', val);

  const setUpCaretIndex = () => {
    if (showRawHtml) {
      const textAreaWrapperEl = textAreaInstance.current.element();
      const textAreaRef = textAreaWrapperEl.children[0].children[0].children[0];
      const { selectionStart } = textAreaRef;

      setCaretIndex(selectionStart);
    } else {
      const selection = htmlEditorInstance.current.getSelection();

      if (selection) {
        setCaretIndex(selection.index);
      } else {
        setCaretIndex(null);
      }
    }
  };

  const handleDrop = ({ dataTransfer }) => {
    const name = dataTransfer.getData('name');
    const validCaretIndex =
      caretIndex.current === null ? 0 : caretIndex.current;

    if (name) {
      if (showRawHtml) {
        const textAreaValue = getTextVal();

        const firstPart = textAreaValue.substring(0, validCaretIndex);
        const secondPart = textAreaValue.substring(validCaretIndex);

        const newVal = `${firstPart}{${name}}${secondPart}`;

        setTextVal(newVal);
      } else {
        htmlEditorInstance.current.insertText(validCaretIndex, `{${name}}`);
      }
    }
  };

  return [handleDrop, setUpCaretIndex];
};

export default useGrid;
